"use client";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import Link from "next/link";
import React, { useState, useEffect } from "react";
import { faqs as staticFaqs } from "@/data/faq";

export default function EventDetails({ slug }) {
  const [eventData, setEventData] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventAndFaqs = async () => {
      try {
        // 1. Fetch Event Data
        const response = await fetch("/api/events");
        const data = await response.json();
        if (data && data.length > 0) {
          const eventsDoc = data[0];
          const foundEvent = eventsDoc.events.find(
            (e) => e.category_title.toLowerCase().replace(/\s+/g, "-") === slug,
          );

          if (foundEvent) {
            setEventData(foundEvent);

            // 2. Fetch FAQs for this event category
            const faqResponse = await fetch(
              `/api/events-faq?subcategory_id=${foundEvent._id}`,
            );
            if (faqResponse.ok) {
              const faqData = await faqResponse.json();
              setFaqs(faqData);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching event data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchEventAndFaqs();
    }
  }, [slug]);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "80vh", width: "100%" }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{
            color: "var(--theme-color, #F55B1F)",
            width: "3rem",
            height: "3rem",
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!eventData) {
    return <div className="text-center py-5">Event not found</div>;
  }

  const whyoptions = [
    {
      id: 1,
      icon: "/assets/img/birthday-cake.png",
      title: "Customized for you!",
    },
    {
      id: 2,
      icon: "/assets/img/satisfaction.png",
      title: "100% Customer Satisfaction",
    },
    {
      id: 3,
      icon: "/assets/img/party-popper.png",
      title: "Easy,Fast, Fun",
    },
  ];

  const swiperOptions = {
    spaceBetween: 30,
    speed: 2000,
    loop: true,
    modules: [Autoplay, Pagination, Navigation],
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".dot",
      clickable: true,
    },
    navigation: {
      nextEl: ".array-next",
      prevEl: ".array-prev",
    },
    breakpoints: {
      1399: { slidesPerView: 3 },
      1199: { slidesPerView: 3 },
      991: { slidesPerView: 2 },
      767: { slidesPerView: 2 },
      575: { slidesPerView: 1 },
      0: { slidesPerView: 1 },
    },
  };

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: `url(${eventData.banner || "/assets/img/breadcrumb-bg.jpg"})`,
        }}
      >
        <div className="shape-image float-bob-y">
          <Image
            src="/assets/img/vector.png"
            width={84}
            height={186}
            alt="img"
          />
        </div>
        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  {eventData.category_title}
                </h1>
              </div>
              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href={`/`}> Home </Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>{eventData.category_title}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5 packagefulldetails">
        <div className="row">
          <div className="col-lg-7 col-md-12 col-sm-12 align-self-center">
            <h2 className="pb-4">{eventData.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: eventData.description }} />
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            <div className="position-relative  h-100 overflow-hidden rounded-4">
              <img
                src={eventData.image || "/assets/img/faqbg.png"}
                width={542}
                height={650}
                alt="img"
                className="faqbg w-100 h-100"
                style={{
                  objectFit: "cover",
                  minHeight: "400px",
                  filter: "brightness(0.7)",
                }}
              />
              {eventData.image_title && (
                <div
                  className="position-absolute bottom-0 start-0 w-100 p-3 text-white text-center"
                  style={{
                    background: "linear-gradient(transparent, rgba(0,0,0,0.8))",
                    fontSize: "22px",
                    fontWeight: "500",
                    fontFamily: "var(--font-chewy, system-ui)",
                  }}
                >
                  {eventData.image_title}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container whychoosebox">
                <div className="row pb-4">
                    <div className="why-box card mb-3" style={{ minHeight: "inherit" }}>
                        <div className="row">
                            <div className="col-lg-12 col-md-6 col-sm-12" >
                                <div className="row">
                                    {whyoptions.map(whyitem => (
                                        <div className="col-lg-4" key={whyitem.id}>
                                            <div className="card-body text-center">
                                                <div className="why-icon">
                                                    <img src={whyitem.icon} alt={whyitem.title} width={64} height={64} className="mb-2" />
                                                </div>
                                                <div className="why-content">
                                                    <h4 className="pb-0">{whyitem.title}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
      {eventData.gallery && eventData.gallery.length > 0 && (
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-center pb-4">Gallery</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <Swiper {...swiperOptions} className="swiper service-slider">
                {eventData.gallery.map((img, index) => (
                  <SwiperSlide key={index} className="swiper-slide">
                    <div className="position-relative mb-4 overflow-hidden rounded-4">
                      <img
                        src={img.url || img}
                        width={346}
                        height={236}
                        alt={img.title || `Gallery image ${index + 1}`}
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "236px",
                          display: "block",
                          filter: "brightness(0.7)",
                        }}
                      />
                      {img.title && (
                        <div
                          className="position-absolute bottom-0 start-0 w-100 p-2 text-white text-center"
                          style={{
                            background:
                              "linear-gradient(transparent, rgba(0,0,0,0.8))",
                            fontSize: "26px",
                            fontWeight: "300",
                            fontFamily: "var(--font-chewy, system-ui)",
                          }}
                        >
                          {img.title}
                        </div>
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="array-button d-flex gap-3 mb-4 justify-content-center mt-4">
                <button
                  className="array-prev snbp1"
                  style={{
                    backgroundColor: "var(--theme-color, #F55B1F)",
                    color: "white",
                    border: "none",
                  }}
                >
                  <i className="fa-regular fa-arrow-left-long"></i>
                </button>
                <button
                  className="array-next snbn1"
                  style={{
                    backgroundColor: "var(--theme-color, #F55B1F)",
                    color: "white",
                    border: "none",
                  }}
                >
                  <i className="fa-regular fa-arrow-right-long"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {faqs && faqs.length > 0 && (
        <section className="faq-section fix section-padding section-bg-2 bg-cover">
          <div className="container pb-4">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-center pb-3">FAQ's</h2>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-8 faq-wrapper">
                <div className="faq-accordion">
                  <div className="accordion" id="accordion">
                    {faqs.map((faq, index) => (
                      <div
                        key={faq._id || index}
                        className="accordion-item mb-3 wow fadeInUp"
                        data-wow-delay={`${0.2 * (index + 1)}s`}
                      >
                        <h5 className="accordion-header">
                          <button
                            className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#faq${index}`}
                            aria-expanded={index === 0}
                            aria-controls={`faq${index}`}
                          >
                            {faq.question}
                          </button>
                        </h5>
                        <div
                          id={`faq${index}`}
                          className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                          data-bs-parent="#accordion"
                        >
                          <div className="accordion-body">{faq.answer}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
